// extracted by mini-css-extract-plugin
module.exports = {"image":"header-background_image__214hi","black":"header-background_black__0FV_u"};